import React, { useState } from 'react';
import { MDBContainer, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import CustomHeader from './CustomHeader';
import ActivitiesSection from './ActivitiesSection';
import ScheduleSection from './ScheduleSection';
import FinishedScheduleSection from './FinishedScheduleSection';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Amplify } from 'aws-amplify';
import { get } from 'aws-amplify/api';
import amplifyconfig from '../../../amplifyconfiguration.json';

Amplify.configure(amplifyconfig);

const handleExport = (selectedFormat, schedule, title, timesList) => {

  const keys = schedule.length > 0 ? Object.keys(schedule[0]) : [];
  const columns = ['Rotation', 'Time', ...keys];
  const data = [];

  switch (selectedFormat) {
    case 'pdf':
      const doc = new jsPDF();
      // Calculate the width of the document
      const docWidth = doc.internal.pageSize.getWidth();
      // Get the width of the title
      const titleWidth = doc.getStringUnitWidth(title) * doc.internal.getFontSize() / doc.internal.scaleFactor;
      // Calculate the x-coordinate to center the title
      const titleX = (docWidth - titleWidth) / 2;
      // Add the title to the PDF
      doc.text(title, titleX, 10);
      // Add the schedule data
      schedule.forEach((dictionary, index) => {
        const rowData = [`Rotation ${index + 1}`, timesList[index], ...keys.map((key) => dictionary[key])];
        data.push(rowData);
      });
      // Add the table to the PDF
      doc.autoTable({
        head: [columns],
        body: data,
      });
      // Save the PDF
      doc.save('finished_schedule.pdf');
      break;
    case 'csv':
      data.push(title);
      data.push(columns.join(','));
      schedule.forEach((dictionary, index) => {
        const rowData = [`Rotation ${index + 1}`, timesList[index], ...keys.map((key) => dictionary[key])];
        data.push(rowData.join(','));
      });
      const csvBlob = new Blob([data.join('\n')], { type: 'text/csv' });
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(csvBlob);
      downloadLink.download = 'finished_schedule.csv';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      break;
    default:
      break;
  }
};


function BuilderTable() {
  const [title, setTitle] = useState("Schedule Name");
  const [activityList, setActivityList] = useState([]);
  const [numGroups, setNumGroups] = useState(1);
  const [timesList, setTimesList] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [isEditing, setIsEditing] = useState(true);

  async function generateSchedule(buttonRef) {
    try {
      buttonRef.style.cursor = 'wait';
      const restOperation = get({ apiName: 'userapi', path: '/algo', options: {queryParams: {totalGroups: numGroups, activities: JSON.stringify(activityList)}} });
      const { body } = await restOperation.response;
      const schedule = await body.json();
      buttonRef.style.cursor = 'pointer';

      if (Object.keys(schedule).length === 0) {
        alert("This schedule is not possible, please make changes.")
      } else {
        setIsEditing(!isEditing);
        setSchedule(schedule);
      }
      } catch (error) {
        console.log(error)
        console.log("ERROR: GS01");
      }    
  }

  const handleActivityListChange = (newActivityList) => {
    setActivityList(newActivityList);
  }

  const handleTimesListChange = (newTimesList) => {
    setTimesList(newTimesList);
  }

  return (
    
    <MDBContainer style={{ marginTop: isEditing ? "2rem" : "15rem" }}>
      <MDBTable responsive style={{ width: '100%', margin: '0 auto'}}>
        <MDBTableHead className='text-center'>
          <CustomHeader initialTitle={title} onTitleChange={(newTitle) => setTitle(newTitle)} isEditingTable={isEditing} />
        </MDBTableHead>
        <MDBTableBody className={isEditing ? '' : 'visually-hidden'}>
            <ActivitiesSection
              onActivityListChange={handleActivityListChange}
              activityList={activityList}
              timesList={timesList} // Pass timesList to ActivitiesSection
              onTimesListChange={handleTimesListChange}
            />
            <ScheduleSection
              activityList={activityList}
              numGroups={numGroups}
              setNumGroups={setNumGroups}
              timesList={timesList} // Pass timesList to ScheduleSection
              onTimesListChange={handleTimesListChange}
            />
        </MDBTableBody>
      </MDBTable>
      {!isEditing && (<FinishedScheduleSection schedule={schedule} numGroups={numGroups} timesList={timesList} />)}
      <div className="text-center" style={{marginTop:'1rem'}}>
        {isEditing ? (
          <button className="btn" style={{ backgroundColor: "#6161FF", color: "#fff" }} onClick={(e) => generateSchedule(e.target)}>Generate Schedule</button>
        ) : (
          <button className="btn" style={{ backgroundColor: "#6161FF", color: "#fff" }} onClick={() => setIsEditing(true) }>Edit Schedule</button>
        )}
        {!isEditing && (
          <button className="btn" style={{ backgroundColor: "#7b7bff ", color: "#fff" }} onClick={() => handleExport('csv', schedule, title, timesList)}>Export as CSV</button>
        )}
        {!isEditing && (
          <button className="btn" style={{ backgroundColor: "#7b7bff ", color: "#fff" }} onClick={() => handleExport('pdf', schedule, title, timesList)}>Export as PDF</button>
        )}
      </div>
    </MDBContainer>
  );
}

export default BuilderTable;